import "./App.css";
import { maxGuesses, seed, urlParam } from "./util";
import Game from "./Game";
import { useEffect, useState } from "react";
import { About } from "./About";
import { Endstate } from "./Endstate";
import { endStatePage } from "./Game";

function useSetting<T>(
  key: string,
  initial: T
): [T, (value: T | ((t: T) => T)) => void] {
  const [current, setCurrent] = useState<T>(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initial;
    } catch (e) {
      return initial;
    }
  });
  const setSetting = (value: T | ((t: T) => T)) => {
    try {
      const v = value instanceof Function ? value(current) : value;
      setCurrent(v);
      window.localStorage.setItem(key, JSON.stringify(v));
    } catch (e) {}
  };
  return [current, setSetting];
}

var tzoffset = (new Date()).getTimezoneOffset() * 60000;
var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);

export const todaySeed = localISOTime.replace(/-/g, "").slice(0, 8);

function App() {

  type Page = "game" | "about" | "settings" | "endstate";
  const [page, setPage] = useState<Page>("game");
  const prefersDark =
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: dark)").matches;
  const [dark, setDark] = useSetting<boolean>("dark", prefersDark);
  const [colorBlind, setColorBlind] = useSetting<boolean>("colorblind", false);
  const [difficulty, setDifficulty] = useSetting<number>("difficulty", 0);
  //const [keyboard, setKeyboard] = useSetting<string>(
  //  "keyboard",
  //  "qwertyuiop-asdfghjkl-BzxcvbnmE"
  //);
  //const [enterLeft, setEnterLeft] = useSetting<boolean>("enter-left", false);

  useEffect(() => {
    document.body.className = dark ? "dark" : "";
    if (urlParam("today") !== null || urlParam("todas") !== null) {
      document.location = "?seed=" + todaySeed;
    }
    setTimeout(() => {
      // Avoid transition on page load
      document.body.style.transition = "0.3s background-color ease-out";
    }, 1);
  }, [dark]);


  const link = (emoji: string, label: string, page: Page) => (
    <button
      className="emoji-link"
      onClick={() => setPage(page)}
      title={label}
      aria-label={label}
    >
      {emoji}
    </button>
  );

    return (
        <div className={"App-container" + (colorBlind ? " color-blind" : "")}>
            <div className="App-header">
            <h1>PRATTLE</h1>
            <p
                className="subline">A word game from the Folger Shakespeare Library</p>
                <hr />
            <div className="top-right">
        {page !== "game" ? (
          link("X", "Close", "game")
        ) : (
          <>
            {link("?", "About", "about")}
            {link("⚙", "Settings", "settings")}
          </>
        )}
          </div>

            <div
                className="folger-home"
        style={{
          position: "absolute",
          left: 5,
          top: 10,
        }}
                ><a href="https://folger.edu" target="_blank"><img src="images/FSL_Favicon_512x512_Red_RGB.svg"></img></a>
                </div>
                </div>
      {page === "endstate" && <Endstate />}
      {page === "about" && <About />}
      {page === "settings" && (
        <div className="Settings">
          <div className="Settings-setting">
            <input
              id="dark-setting"
              type="checkbox"
              checked={dark}
              onChange={() => setDark((x: boolean) => !x)}
            />
            <label htmlFor="dark-setting">Dark theme</label>
          </div>

          <div className="Settings-setting">
            <input
              id="difficulty-setting"
              type="range"
              min="0"
              max="2"
              value={difficulty}
              onChange={(e) => setDifficulty(+e.target.value)}
            />
            <div>
              <label htmlFor="difficulty-setting">Difficulty:</label>
              <strong>{["Normal", "Hard", "Ultra Hard"][difficulty]}</strong>
              <div
                style={{
                  fontSize: 14,
                  height: 40,
                  marginLeft: 8,
                  marginTop: 8,
                }}
              >
                {
                  [
                    `Guesses must be words from Shakespeare's plays, poems and sonnets.`,
                    `Correct letters must stay fixed, and letters that appear in the word but are in the wrong spot must be reused`,
                    `Letters that appear in the word but are in the wrong spot must move away from where they were initially guessed, and gray clues must be obeyed.`,
                  ][difficulty]
                }
              </div>
            </div>
          </div>










        </div>
      )}
      <Game
        maxGuesses={maxGuesses}
        hidden={page !== "game"}
        difficulty={difficulty}
        colorBlind={colorBlind}
        //keyboardLayout={keyboard.replaceAll(
        //  /[BE]/g,
        //  (x) => (enterLeft ? "EB" : "BE")["BE".indexOf(x)]
        //)}
      />
    </div>
    );
}

export default App;
